/**
 * Vite entry. Mounts <App/> into #root and pulls in the global stylesheet
 * which imports `@sill/ui/css/reset` and `@sill/ui/css/theme`. <FontLoader/>
 * is mounted inside <App/> (under the ThemeProvider) rather than here so the
 * lifecycle is tied to the app tree.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Sill dashboard: #root element missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
